module.exports = __webpack_public_path__ + "admin/img/add_item_step4_state.34c380d5.png";